import { Observable } from 'rxjs';
import { PostalCodeInfo } from '../models/postal-code-info';

/**
 * Puerto del dominio para consultar información de un CP. La implementación
 * concreta (HTTP a SEPOMEX, dataset local, mock) se inyecta vía DI en
 * `app.config.ts`. El dominio NO conoce a Angular ni a HttpClient.
 *
 * Contrato:
 * - `lookup(cp)` retorna un Observable que emite `null` si el CP no existe,
 *   no se pudo resolver, o el servicio externo falla. NUNCA emite error
 *   (la implementación lo atrapa) — así la UI puede ignorar el resultado y
 *   permitir captura manual sin interrumpir el flujo del usuario.
 */
export abstract class PostalCodeRepository {
  abstract lookup(cp: string): Observable<PostalCodeInfo | null>;
}
